import { BulletResults } from '../BulletResults/BulletResults'
import { insightTabs } from '../../Insights'
import { VisualizeTree } from '../VisualizeTree/VisualizeTree'
import { InfoIcon, ShareIcon } from '@phosphor-icons/react'
import { ScoopGrid, ScoopTooltip, ScoopButton, ScoopText } from '../../../../ui'
import styles from './TargetColumnResult.module.scss'

export const TargetColumnResult = ({
    mlResults,
    selectedTab,
    setSelectedTab,
    setMlResults,
    mlConfig,
    setMlConfig,
}) => {
    const handleOpenInStudio = () => {
        if (setSelectedTab) {
            setSelectedTab(insightTabs[1].key)
            setMlResults(mlResults)
            mlConfig.dateToUSe = mlResults.filterDate
            mlConfig.modelType = 'cluster'
            if (mlResults.filter) {
                mlConfig.filter = mlResults.filter
                mlConfig.filterDescription = mlResults.filterDescription
            }
            setMlConfig({ ...mlConfig })
        }
    }

    return (
        <>
            {mlResults && mlResults.error && (
                <div className={styles.errorContainer}>
                    <BulletResults mlResults={mlResults} />
                </div>
            )}
            {mlResults && mlResults.numInstances && (
                <div className={styles.resultsContainer}>
                    <ScoopGrid container gap={16} className={styles.gridContainer}>
                        <ScoopGrid item xs={11}>
                            <ScoopText variant="h2" className={styles.title}>
                                Analysis of{' '}
                                {mlConfig && mlConfig.targetColumn
                                    ? mlConfig.targetColumn
                                    : mlResults.targetColumn}
                                <ScoopTooltip
                                    title={
                                        'This analysis is the result of building a model to predict the target value ' +
                                        (mlConfig && mlConfig.targetColumn
                                            ? mlConfig.targetColumn
                                            : mlResults.targetLabel) +
                                        ' using the other columns in the dataset. It may build several different machine learning models to compare which one predicts the target the best and then picking the best one.'
                                    }
                                >
                                    <InfoIcon size={14} className={styles.superAlign} />
                                </ScoopTooltip>
                            </ScoopText>
                        </ScoopGrid>
                        <ScoopGrid item xs={1}>
                            {selectedTab === insightTabs[0].key && (
                                <ScoopTooltip title={'Open in Data Science Discovery Studio'}>
                                    <ScoopButton variant="icon" onClick={handleOpenInStudio}>
                                        <ShareIcon size={20} />
                                    </ScoopButton>
                                </ScoopTooltip>
                            )}
                        </ScoopGrid>
                        <ScoopGrid item xs={6} className={styles.metadataBox}>
                            <div>
                                <strong>Number of models run:</strong> {mlResults.numModels}
                            </div>
                            <div>
                                <strong>Data rows:</strong>{' '}
                                {(mlResults.numInstances ?? 0).toLocaleString()}
                            </div>
                        </ScoopGrid>
                        <ScoopGrid item xs={6} className={styles.metadataBox}>
                            <div>
                                <strong>Best model accuracy:</strong>{' '}
                                {((1 - mlResults.minErrorRate) * 100).toFixed(1) + '%'}
                                <ScoopTooltip
                                    title={
                                        <div className={styles.tooltipContent}>
                                            <div>
                                                Model accuracy is the percentage of times the model
                                                was correct when applied to the data (when presented
                                                with a row from the data and asked to guess, did the
                                                model predict the actual value).
                                            </div>
                                            <div className={styles.tooltipSection}>
                                                The false positive error rate (percentage of times
                                                when the model guess that the result was true
                                                incorrectly) was:{' '}
                                                {(mlResults.falsePositiveRate * 100).toFixed(1) +
                                                    '%'}
                                            </div>
                                            <div className={styles.tooltipSection}>
                                                The false negative error rate (percentage of times
                                                when the model guess that the result was false
                                                incorrectly) was:{' '}
                                                {(mlResults.falseNegativeRate * 100).toFixed(1) +
                                                    '%'}
                                            </div>
                                        </div>
                                    }
                                >
                                    <InfoIcon size={14} />
                                </ScoopTooltip>
                            </div>
                            <div>{mlResults.resampled ? 'Resampled to balance data' : ''}</div>
                        </ScoopGrid>
                        <ScoopGrid item xs={12} className={styles.metadataBox}>
                            <div>
                                <strong>Columns used:</strong>
                                &nbsp;
                                {mlResults?.columns.map((col) => col.name).join(', ')}
                                <ScoopTooltip title="From highest signifance to lowest">
                                    <InfoIcon size={14} />
                                </ScoopTooltip>
                            </div>
                            {mlResults?.filterDescription && (
                                <div>
                                    <strong>Filters:</strong>&nbsp;{mlResults?.filterDescription}
                                </div>
                            )}
                        </ScoopGrid>
                        {mlResults.graph && (
                            <ScoopGrid item xs={12}>
                                <VisualizeTree graph={mlResults.graph} />
                            </ScoopGrid>
                        )}
                        <ScoopGrid item xs={12} className={styles.bulletSection}>
                            <BulletResults mlResults={mlResults} />
                        </ScoopGrid>
                    </ScoopGrid>
                </div>
            )}
        </>
    )
}
